import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { TicketCard } from "../components/TicketCard";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export default function Ticket() {
  const { code } = useParams();
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/bookings/lookup/${code}`)
      .then(({ data }) => setBooking(data))
      .catch(() => setError("We couldn't find that booking code. Double-check it and try again."))
      .finally(() => setLoading(false));
  }, [code]);

  return (
    <div className="min-h-screen bg-[#eae4da]">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        {loading && (
          <div className="flex justify-center py-20">
            <Loader2 className="animate-spin text-[#1d1d1b]" size={28} />
          </div>
        )}
        {!loading && error && (
          <div data-testid="ticket-error" className="card-soft p-10 text-center max-w-lg mx-auto">
            <p className="font-editorial text-2xl text-neutral-500">{error}</p>
            <Link to="/" className="btn-dark inline-flex mt-6 rounded-full px-6 py-3 text-sm font-bold">
              Back to MAS Arts
            </Link>
          </div>
        )}
        {!loading && booking && (
          <motion.div
            data-testid="ticket-page"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <h1 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl">
              You're Booked,{" "}
              <span className="font-editorial italic font-medium text-[#c63f3e]">{booking.guest_name}!</span>
            </h1>
            <p className="text-sm sm:text-base text-neutral-500 font-medium mt-3 mb-8">
              Show your booking code when you arrive — all supplies, snacks and drinks are included.
            </p>
            <TicketCard
              booking={{
                ...booking,
                image: booking.workshop_image,
              }}
            />
          </motion.div>
        )}
      </main>
      <Footer />
    </div>
  );
}
